import { render, staticRenderFns } from "./Inventory-settings.vue?vue&type=template&id=5416cd86&scoped=true"
import script from "./Inventory-settings.vue?vue&type=script&lang=js"
export * from "./Inventory-settings.vue?vue&type=script&lang=js"
import style0 from "./Inventory-settings.vue?vue&type=style&index=0&id=5416cd86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5416cd86",
  null
  
)

export default component.exports